import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicTimeline from './BasicTimeline';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicTimeline, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/timeline/demos/basic/BasicTimeline.tsx",
    "fileName": "BasicTimeline.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Timeline from '@mui/lab/Timeline';\nimport TimelineItem from '@mui/lab/TimelineItem';\nimport TimelineSeparator from '@mui/lab/TimelineSeparator';\nimport TimelineConnector from '@mui/lab/TimelineConnector';\nimport TimelineContent from '@mui/lab/TimelineContent';\nimport TimelineDot from '@mui/lab/TimelineDot';\n\nexport default function BasicTimeline() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Timeline>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot />\n          <TimelineConnector />\n        </TimelineSeparator>\n        <TimelineContent>Eat</TimelineContent>\n      </TimelineItem>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot />\n          <TimelineConnector />\n        </TimelineSeparator>\n        <TimelineContent>Code</TimelineContent>\n      </TimelineItem>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot />\n        </TimelineSeparator>\n        <TimelineContent>Sleep</TimelineContent>\n      </TimelineItem>\n    </Timeline>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 33,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Timeline from '@mui/lab/Timeline';\nimport TimelineItem from '@mui/lab/TimelineItem';\nimport TimelineSeparator from '@mui/lab/TimelineSeparator';\nimport TimelineConnector from '@mui/lab/TimelineConnector';\nimport TimelineContent from '@mui/lab/TimelineContent';\nimport TimelineDot from '@mui/lab/TimelineDot';\n\nexport default function BasicTimeline() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Timeline>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot />\n          <TimelineConnector />\n        </TimelineSeparator>\n        <TimelineContent>Eat</TimelineContent>\n      </TimelineItem>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot />\n          <TimelineConnector />\n        </TimelineSeparator>\n        <TimelineContent>Code</TimelineContent>\n      </TimelineItem>\n      <TimelineItem>\n        <TimelineSeparator>\n          <TimelineDot />\n        </TimelineSeparator>\n        <TimelineContent>Sleep</TimelineContent>\n      </TimelineItem>\n    </Timeline>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 33,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/lab/Timeline",
      "@mui/lab/TimelineItem",
      "@mui/lab/TimelineSeparator",
      "@mui/lab/TimelineConnector",
      "@mui/lab/TimelineContent",
      "@mui/lab/TimelineDot"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
